import { Stack, Typography } from "@mui/material";
import { Donut } from "@poseidon/ui/components/chart/Donut/Donut";

export function CreditScoreDonut({ value, title }) {
  if (!value) {
    return null;
  }
  return (
    <Stack textAlign="center" spacing={1}>
      <Typography variant="subtitle2">{title}</Typography>
      <Stack
        sx={{
          p: 2,
        }}
        flexDirection="row"
        justifyContent="center"
      >
        <Donut
          capStyle="round"
          min={500}
          max={1500}
          radius={70}
          value={value}
        />
      </Stack>
    </Stack>
  );
}
